export default __webpack_public_path__ + "static/kw-5172371c03e034f0cab46ba16b19c32e.svg";